import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Spinner } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { getDriverDetail } from "../../../../api/driver";
import { FileUpload, Input } from "../../../../components";
import dayjs from "dayjs";

const DriverDrivingLicense = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const form = useForm();

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getDriverDetail(id);
            setDetail(response);

            // Set form values for file uploads
            if (response.drivingLicenseFront) {
                form.setValue("drivingLicenseFront", response.drivingLicenseFront);
            }
            if (response.drivingLicenseBack) {
                form.setValue("drivingLicenseBack", response.drivingLicenseBack);
            }
        } catch (error) {
            console.error("Error fetching driver details:", error);
        } finally {
            setLoading(false);
        }
    }, [id, form]);

    useEffect(() => {
        getData();
    }, [getData]);

    const formatDate = (dateString) => {
        return dateString ? dayjs(dateString).format("DD/MM/YYYY") : t("NOT_AVAILABLE");
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">{t("LOADING")}</span>
                </Spinner>
            </div>
        );
    }

    return (
        <FormProvider {...form}>
            <Row>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("DRIVING_LICENSE_FRONT")}
                        name="drivingLicenseFront"
                        readOnly={true}
                        fileName={detail.drivingLicenseFront?.originalName || detail.drivingLicenseFront?.name}
                        uploadProps={{
                            className: "w-100"
                        }}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("DRIVING_LICENSE_BACK")}
                        name="drivingLicenseBack"
                        readOnly={true}
                        fileName={detail.drivingLicenseBack?.originalName || detail.drivingLicenseBack?.name}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <Input
                        label={t("DRIVING_LICENSE_CLASS_TYPE")}
                        name="drivingLicenseClassType"
                        formControlProps={{
                            disabled: true,
                            value: detail.drivingLicenseClassType || ""
                        }}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <Input
                        label={t("DRIVING_LICENSE_EXPIRY_DATE")}
                        name="drivingLicenseExpiryDate"
                        formControlProps={{
                            disabled: true,
                            value: formatDate(detail.drivingLicenseExpiryDate)
                        }}
                    />
                </Col>
            </Row>
        </FormProvider>
    );
};

export default DriverDrivingLicense;
